import { useParams,useLocation } from "react-router";
import BlocsItemComponent from "../../components/Blocs/BlocsItem";
import { useBlocsByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";


function BlocsItem(){
    const location = useLocation();
    const state = location.state as LocationState | undefined;
    const params = useParams();
    const { data: bloc, error, isLoading } = useBlocsByIdQuery((params.id)??"0");
    const {translate}=useTrads();
    
    return (

        
        error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        bloc &&
        <>
          {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_bloc_update')}</p>}
          <BlocsItemComponent bloc={bloc}  />
        
        </>

    );
}
export default BlocsItem;